import React, { useState } from 'react';

import Inner, {
  WebformWizardPageInnerAnimated as InnerAnimated,
  type WebformWizardPageInnerProps,
} from './Inner';

export interface WebformWizardPageProps extends Omit<WebformWizardPageInnerProps, 'isCurrentPage'> {
  addTransitions?: boolean;
}

const WebformWizardPage: React.FC<WebformWizardPageProps> = (props) => {
  const {
    entity,
    currentPage,
    addTransitions = false,
    ...restProps
  } = props;

  const isCurrentPage = currentPage === entity.get('#webform_key');
  const InnerComponent = addTransitions ? InnerAnimated : Inner;

  const [isTransitioning, setTransitioning] = useState(false);

  return (
    <InnerComponent
      {...restProps}
      entity={entity}
      currentPage={currentPage}
      isCurrentPage={isCurrentPage}
      // Following props are for the withTransitions HOC.
      isVisible={isCurrentPage}
      motionConfig={{
        transition: { duration: 1 },
      }}
      motionProps={{
        className: isTransitioning ? 'WebformWizardPage--is-transitioning' : '',
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { delay: 0.7 } },
        exit: { opacity: 0, transition: { delayChildren: 0.7 } },
        onAnimationStart: () => setTransitioning(true),
        onAnimationComplete: () => setTransitioning(false),
      }}
    />
  );
};

export default WebformWizardPage;
